<template>
  <a-card :bordered="false" title="*开启直播后需要在小程序中开启直播权限，并创建直播间、添加直播商品。">
    <a-radio-group
      style="margin-bottom: 20px"
      v-model="listType"
    >
      <a-radio-button :value="1">直播商品</a-radio-button>
      <a-radio-button :value="2">直播列表</a-radio-button>
    </a-radio-group>
    <div v-if="listType===1" style="margin-bottom: 20px">
      <a-button type="primary" @click="addProductEvent">添加商品</a-button>
      <a-button style="float: right" type="primary" @click="settingEvent">直播设置</a-button>
    </div>
    <custom-page-table
      ref="tableList"
      :queryParams="queryParams"
      :columns="listType===1?getProductColumns():getPlayerColumns()"
      :request-promise="getRequestPromise"
    >
      <template slot="customIndex" slot-scope="rowItem">{{ rowItem.index + 1 }}</template>
      <template slot="liveStatus" slot-scope="rowItem">{{ rowItem.text|livePlayerStateName }}</template>
      <template slot="platformStatusSlot" slot-scope="rowItem">{{ rowItem.text == 0 ? '隐藏' : '显示' }}</template>
      <template slot="customizeBillSlot" slot-scope="rowItem">{{ rowItem.text == 0 ? '未设置' : '已上传' }}</template>
      <span slot="action" slot-scope="rowItem">
        <a-popconfirm
          v-if="listType===1"
          title="你确定要删除当前直播商品吗?"
          @confirm="deleteGoodsEvent(rowItem.record)">
          <a>删除</a>
        </a-popconfirm>
        <template v-else>
          <a v-if="rowItem.record.platformStatus==0" @click="confirmUpdate(rowItem.record.roomId,1)">显示</a>
          <a v-else @click="confirmUpdate(rowItem.record.roomId,0)">隐藏</a>
          <a-divider type="vertical"></a-divider>
          <a @click="uploadPosterEvent(rowItem.record)">上传海报</a>
          <span v-if="rowItem.record.liveStatus==103">
            <a-divider type="vertical"></a-divider>
            <a @click="downloadVideo(rowItem.record.roomId)">下载视频</a>
          </span>
        </template>
      </span>
    </custom-page-table>
    <a-modal
      title="直播设置"
      :visible="visible"
      :footer="null"
      @cancel="visible = false"
      :width="400"
    >
      <a-form-model>
        <a-form-model-item>
          <a-radio-group v-model="liveStatus">
            <a-radio :value="1">开启</a-radio>
            <a-radio :value="2">关闭</a-radio>
          </a-radio-group>
        </a-form-model-item>
      </a-form-model>
      <a-button :loading="saveLoading" type="primary" @click="saveSettingEvent">保存设置</a-button>
    </a-modal>
    <a-modal
      title="添加商品"
      :visible="addDialogVisible"
      :footer="null"
      @cancel="addDialogVisible = false"
      :width="800"
    >
      <a-form-model
        :label-col="currentFormLayout.labelCol"
        :wrapper-col="currentFormLayout.labelCol"
        ref="addForm"
        :model="addForm"
        :rules="addRules"
      >
        <a-form-model-item label="关联直播间" :required="true" prop="liveRoomId">
          <a-select
            v-model="addForm.liveRoomId"
            :disabled="false"
            style="width: 400px"
            placeholder="请选择"
          >
            <a-select-option v-for="item in roomList" :key="item.roomId" :value="item.roomId">{{ item.roomName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item
          label="关联商品"
          :required="true"
          prop="commodityId"
        >
          <div style="width: 400px" @click="toSelectedProductEvent">
            <a-button>选择商品</a-button>
            <span v-if="addForm.commodityName" style="margin-left: 10px;">{{ addForm.commodityName }}</span>
          </div>
        </a-form-model-item>
        <a-form-model-item
          label="  "
          :colon="false"
          :required="false"
        >
          <a-button :loading="saveLoading" type="primary" @click="saveProductEvent">保存设置</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <a-modal
      :bodyStyle="{'text-align': 'center','padding':'0','margin': 'auto'}"
      title="添加商品"
      :visible="uploadDialogVisible"
      :footer="null"
      @cancel="uploadDialogVisible = false"
      :width="400"
    >
      <div class="line-text">温馨提示：上传的图片尺寸是1200px*1604px</div>
      <div class="live-player-upload-box">
        <a-upload
          :action="uploadFileUrl"
          :multiple="false"
          :showUploadList="false"
          listType="picture-card"
          @change="fileInfo=>handleFileChange(fileInfo)"
          :before-upload="handleBeforeUploadImage"
        >
          <img v-if="posterUrl" :src="posterUrl" alt="avatar" class="poster-img"/>
          <div v-else>
            <a-icon :type="posterUrl? 'loading' : 'plus'"/>
          </div>
        </a-upload>
        <div v-if="posterUrl" style="height: 401px; width: 300px; position: absolute;top: 0;left: 0;z-index:10;">
          <VueDraggableResizable
            @dragging="onDrag" @resizing="onResize"
            :parent="true"
            :w="width" :h="height" :min-width="45" :min-height="45" :max-height="300" :max-width="300" :x="x" :y="y"
            :z="999" :lock-aspect-ratio="true">
            <div class="drag-box">
              <img :src="qrCodeUrl"/>
            </div>
          </VueDraggableResizable>
        </div>

      </div>
      <div style="text-align:center;padding-top: 40px; padding-bottom: 40px">
        <a-button type="primary" @click="savePosterEvent" :loading="saveLoading">保存</a-button>
        <a-button @click="resetPosterEvent" style="margin-left: 10px">重置</a-button>
      </div>
    </a-modal>
    <selected-product-dialog
      :show="showSelectedDialog"
      :itemNames="['search_proId','search_proName']"
      :query-params="selectedQueryParams"
      :request-promise="getGoodsRequest"
      @close="showSelectedDialog=false"
      :columns="getGoodsColumns()"
    >
      <a-form-item
        label="商品ID"
        slot="search_proId" v-bind="currentFormLayout">
        <a-input
          v-model="selectedQueryParams.proId"
          style="width: 170px"
          placeholder="请输入商品ID"
        ></a-input>
      </a-form-item>
      <a-form-item
        label="商品名称"
        slot="search_proName"
        v-bind="currentFormLayout">
        <a-input
          v-model="selectedQueryParams.proName"
          style="width: 170px"
          placeholder="请输入商品名称"
        ></a-input>
      </a-form-item>
      <template slot="customIndex" slot-scope="rowItem">{{ rowItem.index + 1 }}</template>
      <template slot="proCatalogId" slot-scope="rowItem">{{ rowItem.text|productTypeName }}</template>
      <template slot="action" slot-scope="rowItem">
        <a-button type="primary" @click="onSelectedResult(rowItem.record)">选择</a-button>
      </template>
    </selected-product-dialog>
    <!-- 下载视频 -->
    <a-modal
      title="直播视频"
      :visible="visibleVideo"
      :footer="null"
      @cancel="visibleVideo = false"
      width="750px"
    >
      <a-textarea placeholder="视频链接" v-model="videoUrl" :auto-size="{ minRows: 6, maxRows: 10 }"/>
    </a-modal>
  </a-card>
</template>

<script>
import formMixin from '@/utils/mixins/formMixins'
import SelectedProductDialog from '@/customComponents/SelectedProductDialog/SelectedProductDialog'
import VueDraggableResizable from 'vue-draggable-resizable'
import 'vue-draggable-resizable/dist/VueDraggableResizable.css'

export default {
  name: 'LivePlayerList',
  mixins: [formMixin],
  components: { SelectedProductDialog, VueDraggableResizable },
  data() {
    return {
      currentFormLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 }
      },
      queryParams: {
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId
      },
      selectedQueryParams: { orderByKey: 1, proCatalog: 0 },
      roomList: [],
      liveStatus: 2,
      merchantId: this.$store.getters.userInfo.merchantId,
      listType: 1,
      visible: false,
      addDialogVisible: false,
      showSelectedDialog: false,
      uploadDialogVisible: false,
      visibleVideo: false,
      videoUrl: '',
      addForm: {
        commodityName: '',
        commodityId: undefined,
        liveRoomId: '',
        proImg: ''
      },
      addRules: {
        liveRoomId: [
          { required: true, message: '请选择要关联直播间', trigger: 'blur,change' }
        ],
        commodityId: [
          { required: true, type: 'number', message: '请选择要关联的商品', trigger: 'blur,change' }
        ]
      },
      posterUrl: '',
      qrCodeUrl: '',
      x: 120,
      y: 310,
      width: 65,
      height: 65,
      selectedRoomItem: {}
    }
  },
  watch: {
    'listType': function(value) {
      this.$refs.tableList.refresh(true)
    }
  },
  mounted() {
    this.getRoomList()
  },
  methods: {
    getRoomList() {
      this.getHttpServices().getServerApiService().get('live/style/room/list/' + this.merchantId + '/' + this.getPlatformConfig().platformId)
        .then(list => this.roomList = list)
        .catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getRequestPromise(params) {
      const path = this.listType === 1 ? 'live/room/commodity/list' : 'live/style/room/service/list'
      return this.getHttpServices().getServerApiService().post(path, params)
    },
    getDetail() {
      const path = '/live/style/' + this.merchantId + '/' + this.getPlatformConfig().platformId
      this.getHttpServices().getServerApiService().get(path)
        .then(res => {
          if (res && res.liveStatus) {
            this.liveStatus = res.liveStatus
          } else {
            this.liveStatus = 2
          }
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getQrCordUrl() {
      let platformId = this.getPlatformConfig().platformId
      this.getHttpServices().getProService().get('/public/create/live/qrcode?merchantId=' + this.merchantId + '&platformId=' + platformId)
        .then(url => {
          this.qrCodeUrl = url
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    addProductEvent() {
      this.addForm = {}
      this.addDialogVisible = true
    },
    uploadPosterEvent(record) {
      this.selectedRoomItem = record
      if (!this.qrCodeUrl) {
        this.getQrCordUrl()
      }
      this.getPosterInfo(record)
        .then(info => {
          this.posterUrl = info.posterUrl
          if (this.posterUrl) {
            this.x = info.x / 4
            this.y = info.y / 4
            this.width = info.width / 4
            this.height = info.height / 4
          }
          this.uploadDialogVisible = true
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    settingEvent() {
      this.visible = true
      this.getDetail()
    },
    saveSettingEvent() {
      this.saveLoading = true
      const path = '/live/style/save'
      const params = {
        liveMerchantId: this.merchantId,
        livePlatformId: this.getPlatformConfig().platformId,
        liveStatus: this.liveStatus
      }
      this.getHttpServices().getServerApiService().post(path, params)
        .then(res => {
          let tips = this.liveStatus === 1 ? '开启小程序直播成功' : '关闭小程序直播成功'
          this.$message.success(tips)
          this.visible = false
        }).catch(reason => this.showNetWorkErrorMessage(reason))
        .finally(() => this.saveLoading = false)
    },
    toSelectedProductEvent() {
      this.showSelectedDialog = true
    },
    saveProductEvent() {
      this.$refs['addForm'].validate(valid => {
        if (valid) {
          this.requestSave()
        }
        this.getLogUtils().logWithTag('valid===', valid)
      })
    },
    requestSave() {
      const params = {
        merchantId: this.merchantId,
        platformId: this.getPlatformConfig().platformId,
        ...this.addForm
      }
      this.saveLoading = true
      this.getHttpServices().getServerApiService().post('live/room/commodity/save', params)
        .then(res => {
          this.$message.success('商品添加成功')
          this.addDialogVisible = false
          this.$refs.tableList.refresh(false)
        })
        .catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.saveLoading = false)
    },
    getPlayerColumns() {
      return [
        {
          title: '序号',
          dataIndex: 'customIndex',
          width: '60px',
          scopedSlots: { customRender: 'customIndex' }

        },
        {
          title: '直播间',
          dataIndex: 'roomName'
        },
        {
          title: '状态',
          dataIndex: 'platformStatus',
          width: '100px',
          scopedSlots: { customRender: 'platformStatusSlot' }
        },
        {
          title: '直播状态',
          dataIndex: 'liveStatus',
          width: '100px',
          scopedSlots: { customRender: 'liveStatus' }
        },
        {
          title: '直播海报',
          dataIndex: 'customizeBillStatus',
          width: '160px',
          scopedSlots: { customRender: 'customizeBillSlot' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '220px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    getGoodsRequest(params) {
      return this.getHttpServices().getUserService().post('homepage/recommend/get/modularProduct', params)
    },
    getGoodsColumns() {
      return [
        {
          title: '序号',
          dataIndex: 'customIndex',
          width: '60px',
          scopedSlots: { customRender: 'customIndex' }
        },
        {
          title: '商品名称',
          dataIndex: 'proName'
        },
        {
          title: '商品类型',
          dataIndex: 'proCatalog',
          width: '100px',
          scopedSlots: { customRender: 'proCatalogId' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '100px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    getProductColumns() {
      return [
        {
          title: '序号',
          dataIndex: 'customIndex',
          width: '60px',
          scopedSlots: { customRender: 'customIndex' }
        },
        {
          title: '商品标题',
          dataIndex: 'commodityName'
        },
        {
          title: '关联直播间',
          dataIndex: 'roomName',
          width: '200px'
        },
        {
          title: '创建时间',
          dataIndex: 'gmtCreate',
          width: '160px'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '120px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    deleteGoodsEvent(record) {
      this.getHttpServices().getServerApiService().post('live/room/commodity/delete/' + record.id)
        .then(res => {
          this.$message.success('删除商品成功')
          this.$refs.tableList.refresh(false)
        })
        .catch(reason => this.showNetWorkErrorMessage(reason))
    },
    //商品选择结果
    onSelectedResult(record) {
      this.getLogUtils().logWithTag(record)
      this.addForm.commodityId = record.proId
      this.addForm.commodityName = record.proName
      this.addForm.proImg = record.proImg
      this.showSelectedDialog = false
    },
    handleFileChange(fileInfo) {
      if (fileInfo.file.status === 'done') {
        this.posterUrl = this.getLatestUrlFromFileList(fileInfo.fileList)
      }
    },
    handleBeforeUploadImage(file) {
      this.getLogUtils().logWithTag('handleBeforeUploadImage', file)
      // 限制图片 格式、size、分辨率
      const isJPG = file.type === 'image/jpeg'
      const isJPEG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      if (!(isJPG || isJPEG || isPNG)) {
        this.$message.error('上传图片的格式不正确，不是JPG、JPEG、GIF、PNG')
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('上传的文件不能大于2M!')
        return false
      }
      let that = this
      return new Promise(function(resolve, reject) {
        let filereader = new FileReader()
        let width = 1200
        let height = 1604
        filereader.onload = e => {
          let src = e.target.result
          const image = new Image()
          image.onload = function() {
            let valid = image.width == width && image.height == height
            if (!valid) {
              that.$message.error('上传的图片尺寸必须是1200px*1604px(宽高)')
              reject()
            } else {
              resolve()
            }
          }
          image.onerror = reject
          image.src = src
        }
        filereader.readAsDataURL(file)
      })
      return true
    },
    //调整缩放
    onResize: function(x, y, width, height) {
      this.x = x
      this.y = y
      this.width = width
      this.height = height
    },
    //移动位置
    onDrag: function(x, y) {
      this.x = x
      this.y = y
    },
    savePosterEvent() {
      if (!this.posterUrl) {
        this.$message.error('请选择海报图片')
        return
      }
      this.saveLoading = true
      let tips = '上传海报成功'
      let params = {
        merchantId: this.merchantId,
        platformId: this.getPlatformConfig().platformId,
        qrcodeHeight: this.height * 4,
        qrcodeWidth: this.width * 4,
        qrcodex: this.x * 4,
        qrcodey: this.y * 4,
        roomId: this.selectedRoomItem.roomId,
        templateUrl: this.posterUrl
      }
      this.getHttpServices().getServerApiService().post('live/style/room/poster', params)
        .then(res => {
          this.$message.success(tips)
          this.uploadDialogVisible = false
          this.$refs.tableList.refresh(false)
        })
        .catch(reason => this.showNetWorkErrorMessage(reason))
        .finally(() => this.saveLoading = false)
    },
    resetPosterEvent() {
      this.posterUrl = ''
    },
    getPosterInfo(record) {
      return new Promise((resolve, reject) => {
        const defaultInfo = {
          height: 65,
          width: 65,
          x: 120,
          y: 310,
          posterUrl: ''
        }
        if (record.customizeBillStatus > 0) {
          let platformId = this.getPlatformConfig().platformId
          const path = 'live/style/room/poster/' + this.merchantId + '/' + record.roomId + '/' + platformId
          this.getHttpServices().getServerApiService().get(path)
            .then(res => {
              resolve({
                height: res.qrcodeHeight,
                width: res.qrcodeWidth,
                x: res.qrcodex,
                y: res.qrcodey,
                posterUrl: res.templateUrl
              })
            }).catch(reason => reject(reason))
        } else {
          resolve(defaultInfo)
        }
      })
    },
    confirmUpdate(roomId, status) {
      let that = this
      let title = status == 1 ? '此操作将显示该直播间' : '此操作将隐藏该直播间'
      this.$confirm({
        title: title,
        onOk() {
          that.updateData(roomId, status)
        },
        onCancel() {
          that.$message.warning('已取消')
        }
      })
    },
    // 显示隐藏直播间
    updateData(roomId, status) {
      this.getHttpServices().getServerApiService().post('live/style/room/update/status', {
        merchantId: this.$store.getters.userInfo.merchantId,
        platformStatus: status,
        roomId: roomId,
        platformId: this.getPlatformConfig().platformId
      }).then(res => {
        this.$message.success('操作成功')
        this.$refs.tableList.refresh(false)
      })
        .catch(reason => this.showNetWorkErrorMessage(reason))
    },
    // 下载视频
    downloadVideo(roomId) {
      let merchantId = this.$store.getters.userInfo.merchantId
      let platformId = this.getPlatformConfig().platformId
      this.videoUrl = ''
      this.visibleVideo = true
      this.getHttpServices().getServerApiService().post('live/style/room/replay/' + merchantId + '/' + roomId + '/' + platformId).then(res => {
        if (res && res.length > 0) {
          let arr = []
          res.forEach((item) => {
            arr.push(item.mediaUrl)
          })
          this.videoUrl = arr.join('\n')
        }
      })
        .catch(reason => this.showNetWorkErrorMessage(reason))
    }
  }
}
</script>
<style lang="less">
.inner-size() {
  width: 300px;
  height: 401px;
}

.line-text {
  height: 40px;
  line-height: 40px;
  text-align: center;
  color: red;
}

.drag-box {
  position: relative;
  width: 100%;
  height: 100%;

  img {
    width: 100%;
    height: 100%;
  }
}

.live-player-upload-box {
  margin: 0 auto;
  position: relative;
  .inner-size();

  .ant-upload.ant-upload-select-picture-card > .ant-upload {
    padding: 0;
  }

  .ant-upload.ant-upload-select-picture-card {
    .inner-size();
    padding: 0;
  }

  .ant-upload {
    .inner-size();

    .ant-upload-select-picture-card {
      .inner-size();
      padding: 0;
    }

    .picture-card {
      .inner-size();
    }
  }

  .poster-img {
    .inner-size();
  }

  .picture-card .ant-upload-list-item {
    padding: 0;
  }
}
</style>